/**
 * Formatage localisé des nombres (DECISIONS §9.3 : jamais de format maison, `Intl` uniquement).
 *
 * Les éclats, PV et niveaux sont des entiers : un séparateur de milliers localisé évite les
 * ambiguïtés de lecture (`1 200` en français, `1,200` en anglais).
 */
const formateurs = new Map<string, Intl.NumberFormat>();
const formateursDate = new Map<string, Intl.DateTimeFormat>();

/** Formate un entier selon la langue courante. */
export function formaterNombre(valeur: number, langue: string): string {
  const cle = langue.length > 0 ? langue : 'fr';
  let formateur = formateurs.get(cle);
  if (!formateur) {
    formateur = new Intl.NumberFormat(cle, { maximumFractionDigits: 0 });
    formateurs.set(cle, formateur);
  }
  return formateur.format(valeur);
}

/**
 * Formate un horodatage ISO (`startedAt`, `endedAt`) selon la langue courante.
 *
 * Aucun format n'est écrit à la main (DECISIONS §9.3) : `Intl.DateTimeFormat` choisit l'ordre
 * des champs, les séparateurs et le fuseau du navigateur. Une valeur illisible est renvoyée telle
 * quelle plutôt que remplacée par une date inventée.
 */
export function formaterDate(horodatage: string, langue: string): string {
  const date = new Date(horodatage);
  if (Number.isNaN(date.getTime())) return horodatage;
  const cle = langue.length > 0 ? langue : 'fr';
  let formateur = formateursDate.get(cle);
  if (!formateur) {
    formateur = new Intl.DateTimeFormat(cle, { dateStyle: 'medium', timeStyle: 'short' });
    formateursDate.set(cle, formateur);
  }
  return formateur.format(date);
}
